import {GenApiKeyRequest} from '../../generated/serverModels/GenApiKeyRequest';

export interface CreateApiKeyRequest {
    reason: string;
    supportedSystems: string[];
}


export class ApiKeyRequest extends GenApiKeyRequest {
    constructor(apiKeyRequest?: Partial<ApiKeyRequest>) {
        super(apiKeyRequest);
    }
}
